<!-- <ion-header class="main-fixed-header" [scrollHide]="headerScrollConfig" [scrollContent]="resultSearchContent" style="top: -200px">
  <ion-toolbar id="eventMainSearchbar">
    
    <ion-title>
      {{ 'GLOBAL_SEARCH_RESULTS' | translate }}
    </ion-title>

    <ion-buttons slot="end">
      <ion-button color="primary" fill="clear" (click)="scrollIntoView(searchTop)" 
                  [attr.aria-label]="'GLOBAL_MAPS' | translate">
        <ion-icon name="funnel-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header> -->


<ion-content #resultSearchContent fullscreen>
  <div #searchTop class="results-main-bg-image fullscreen" *ngIf="!noSearchField">
    <span class="results-main-animation-prefix"></span>
    <span class="results-main-color-prefix" *ngIf="picLayout"></span>
    <span class="results-main-color-prefix-simple" *ngIf="!picLayout"></span>

    <ion-row *ngIf="((SECOND_LAYER || THIRD_LAYER) && !searched) || (userSection && !isThurnauApp)"
             class="margin-bottom-negative">
      <ion-col class="col-flex" style="text-align: left;">
        <ion-icon class="icon-left" name="arrow-back"></ion-icon>
        <ion-button fill="clear" color="light" (click)="onBackMenu()">
          <strong>{{ 'GLOBAL_BACK' | translate }}</strong>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="FIRST_LAYER && (appDetector.isForestApp() || (appDetector.isEventsApp() && isBrowser))">
      <ion-col class="col-flex" style="text-align: left;">
        <ion-icon class="icon-left" name="arrow-back"></ion-icon>
        <ion-button fill="clear" color="light" (click)="onPopPage()">
          <strong>{{ 'GLOBAL_BACK' | translate }}</strong>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row class="results-main-header ion-padding-horizontal" style="padding-top: var(--ion-safe-area-top);">
      <ion-col size="8" class="ion-text-start">

        <!-- Conditional title based on user section -->
        <h1 *ngIf="!userSection" class="ion-text-bold" [ngClass]="{'black-font': postbonnClient}">
          {{ 'MAIN_TAB_TITLE_RESULTSEARCH' | translate }}
        </h1>

        <h3 *ngIf="userSection" class="ion-text-bold" [ngClass]="{'black-font': postbonnClient}">
          {{ 'PRIVATEPROFILE_DHL_RESULT' | translate }}
        </h3>

        <h1 *ngIf="test" class="ion-text-bold">
          {{ 'GLOBAL_CANCEL' | translate }}
        </h1>

      </ion-col>

      <ion-col size="4" class="ion-text-end">
        <ion-button *ngIf="showMySport" fill="clear" color="light" (click)="showLogin()"
          [attr.aria-label]="'GLOBAL_MYSPORT' | translate"
          style="margin-top: 1.2rem;">
          
          <span *ngIf="isLoged()" class="user-image-m" [ngStyle]="{'background-image': 'url(' + profileImage() + ')'}" style="border-radius: 50%;"></span>
          
          <span *ngIf="!isLoged()" class="user-image-m" [ngStyle]="{'background-image': 'url(/assets/imgs/default-image-32@1x.png)'}" style="border-radius: 50%;"></span>
          
        </ion-button>
      </ion-col>
    </ion-row>


    <div class="results-main-content" *ngIf="!clientSpecific">
      <div class="results-main-content-inner ion-padding">
        
        <!-- Category Select -->
        <ion-row>
          <ion-col size="12">
            <ion-row class="custom-search-field">
              
              <ion-col size="1">
                <div class="vertical-center-outer">
                  <div class="vertical-center-inner ion-text-center">
                    <mysport-icon [cid]="searchModel.cid" color="light" size="small"></mysport-icon>
                  </div>
                </div>
              </ion-col>
              
              <ion-col size="11" class="custom-search-field-container">
                <!-- <ion-label class="ion-visually-hidden">{{ 'EVENT_CATEGORY' | translate }}</ion-label> -->
                <ion-select [(ngModel)]="searchModel.cid" cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                            okText="{{ 'GLOBAL_OK' | translate }}"
                            interface="alert"
                            [interfaceOptions]="{
                              header: ('EVENT_CATEGORY' | translate)
                            }"
                            >
                  <ion-select-option *ngFor="let category of categories" [value]="category.id">
                    {{ category.name }}
                  </ion-select-option>
                </ion-select>
              </ion-col>

            </ion-row>
          </ion-col>
        </ion-row>

        <!-- Athlete Search Input -->
        <ion-row>
          <ion-col size="12">
            <ion-item class="custom-search-field no-border custom-search-text">
              <ion-icon name="person" slot="start" color="medium"></ion-icon>
              <ion-input type="text" [(ngModel)]="searchModel.sw"
                        placeholder="{{ 'RESULT_SEARCH_ATHLETES NAME' | translate }}">
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <!-- Search Button -->
        <ion-row>
          <ion-col size="12" class="ion-text-center ion-padding-top">
            <ion-button color="light" fill="outline" (click)="onSearch()">
              <ion-icon slot="start" name="search"></ion-icon>
              {{ 'GLOBAL_SEARCH' | translate }}
            </ion-button>
          </ion-col>
        </ion-row>

      </div>
    </div>


    <div class="results-main-content" *ngIf="clientSpecific">
      <div class="results-main-content-inner ion-padding">

        <!-- Search Athletes -->
        <ion-row *ngIf="!userSection && !appDetector.isGesunderApp()">
          <ion-col size="12">
            <ion-item class="custom-search-field no-border custom-search-text">
              <ion-icon name="person" slot="start" color="medium"></ion-icon>
              <ion-input type="text" [(ngModel)]="clientSearchModel.sw"
                placeholder="{{ 'RESULT_SEARCH_ATHLETES NAME' | translate }}"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <!-- Event Categories -->
        <ion-row *ngIf="eventCatergories?.length > 1 || appDetector.isForestApp() || appDetector.isGesunderApp()">
          <ion-col size="12">
            <ion-row class="custom-search-field">
              <ion-col size="1">
                <div class="vertical-center-outer">
                  <div class="vertical-center-inner ion-text-center">
                    <ion-icon color="white" name="help-buoy" class="sportart-icon-big"></ion-icon>
                  </div>
                </div>
              </ion-col>
              <ion-col size="11" class="custom-search-field-container">
                <!-- <ion-label class="ion-sr-only">{{ 'EVENT_CATEGORY' | translate }}</ion-label> -->
                <ion-select [(ngModel)]="clientSearchModel.cid" (ionChange)="eventCategoryChanged()"
                            placeholder="{{ eventCatergories[0]?.name }}"
                            cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                            okText="{{ 'GLOBAL_OK' | translate }}"
                            interface="alert"
                            [interfaceOptions]="{
                              header: ('EVENT_CATEGORY' | translate)
                            }">
                  <ion-select-option *ngFor="let eventCategory of eventCatergories" [value]="eventCategory.value">
                    {{ eventCategory?.name }}
                  </ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>

        <!-- Event Names -->
        <ion-row *ngIf="eventNames?.length > 0 || appDetector.isGesunderApp()">
          <ion-col size="12">
            <ion-row class="custom-search-field">
              <ion-col size="1">
                <div class="vertical-center-outer">
                  <div class="vertical-center-inner ion-text-center">
                    <ion-icon color="white" name="pin" class="sportart-icon-big"></ion-icon>
                  </div>
                </div>
              </ion-col>
              <ion-col size="11" class="custom-search-field-container">
                <!-- <ion-label class="ion-sr-only">{{ 'EVENT_EVENTNAME' | translate }}</ion-label> -->
                <ion-select [(ngModel)]="clientSearchModel.ena" (ionChange)="eventNameChange()"
                            cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                            okText="{{ 'GLOBAL_OK' | translate }}"
                            interface="alert"
                            [interfaceOptions]="{
                              header: ('EVENT_EVENTNAME' | translate)
                            }">
                  <ion-select-option *ngFor="let eventName of eventNames" [value]="eventName.value">
                    {{ eventName.value }}
                  </ion-select-option>
                  <ion-select-option *ngIf="event" [value]="event.name.value">
                    {{ event.name }}
                  </ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>

        <!-- Event Date -->
        <ion-row *ngIf="clientSearchModel.ena?.length > 0">
          <ion-col size="12">
            <ion-row class="custom-search-field">
              <ion-col size="1">
                <div class="vertical-center-outer">
                  <div class="vertical-center-inner ion-text-center">
                    <ion-icon [color]="postbonnClient ? 'black' : 'white'" name="calendar" class="sportart-icon-big"></ion-icon>
                  </div>
                </div>
              </ion-col>
              <ion-col size="11" class="custom-search-field-container">
                <!-- <ion-label class="ion-sr-only">{{ 'EVENT_DATE' | translate }}</ion-label> -->
                <ion-select [(ngModel)]="clientSearchModel.dt" (ionChange)="eventDateChange()"
                            placeholder="{{ 'GLOBAL_PLEASE_SELECT' | translate }}"
                            [ngClass]="{'black-font': postbonnClient }"
                            cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                            okText="{{ 'GLOBAL_OK' | translate }}"
                            interface="alert"
                            [interfaceOptions]="{
                              header: ('EVENT_DATE' | translate)
                            }">
                  <ion-select-option value="">{{ 'GLOBAL_ALL' | translate }}</ion-select-option>
                  <ion-select-option *ngFor="let date of eventDates" [value]="date.value">
                    {{ date.value }}
                  </ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>

        <!-- Event Distance -->
        <ion-row *ngIf="clientSearchModel.dt?.length > 0">
          <ion-col size="12">
            <ion-row class="custom-search-field">
              <ion-col size="1">
                <div class="vertical-center-outer">
                  <div class="vertical-center-inner ion-text-center">
                    <ion-icon [color]="postbonnClient ? 'dark' : 'light'" [style.fill]="postbonnClient ? 'black' : 'white'" name="resize" class="sportart-icon-big"></ion-icon>
                  </div>
                </div>
              </ion-col>
              <ion-col size="11" class="custom-search-field-container">
                <!-- <ion-label class="ion-sr-only" position="fixed">{{ 'EVENT_DISTANCE' | translate }}</ion-label> -->
                <ion-select [(ngModel)]="clientSearchModel.dist" (ionChange)="eventDistanceChange()"
                            placeholder="{{ 'GLOBAL_PLEASE_SELECT' | translate }}"
                            cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                            okText="{{ 'GLOBAL_OK' | translate }}"
                            interface="alert"
                            [interfaceOptions]="{
                              header: ('EVENT_DISTANCE' | translate)
                            }">
                  <ion-select-option value="">{{ 'GLOBAL_ALL' | translate }}</ion-select-option>
                  <ion-select-option *ngFor="let distance of eventDistances" [value]="distance.value">
                    {{ distance.value }}
                  </ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>

        <!-- Event Grading -->
        <ion-row *ngIf="clientSearchModel.dist?.length > 0">
          <ion-col size="12">
            <ion-row class="custom-search-field">
              <ion-col size="1">
                <div class="vertical-center-outer">
                  <div class="vertical-center-inner ion-text-center">
                    <ion-icon [color]="postbonnClient ? 'black' : 'white'" name="pricetag" class="sportart-icon-big"></ion-icon>
                  </div>
                </div>
              </ion-col>
              <ion-col size="11" class="custom-search-field-container">
                <!-- <ion-label class="ion-sr-only">{{ 'EVENT_GRADING' | translate }}</ion-label> -->
                <ion-select [(ngModel)]="clientSearchModel.t" (ionChange)="onSearchClient()"
                            placeholder="{{ 'GLOBAL_PLEASE_SELECT' | translate }}"
                            cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                            okText="{{ 'GLOBAL_OK' | translate }}"
                            interface="alert"
                            [interfaceOptions]="{
                              header: ('EVENT_GRADING' | translate)
                            }">
                  <ion-select-option value="">{{ 'GLOBAL_ALL' | translate }}</ion-select-option>
                  <ion-select-option *ngFor="let type of eventTypes" [value]="type.value">
                    {{ type.value }}
                  </ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>

        <!-- Search Button -->
        <ion-row *ngIf="!userSection">
          <ion-col size="12">
            <div class="ion-text-center ion-padding-top">
              <ion-button  (click)="onSearchClient()">
                <ion-icon slot="start" name="search"></ion-icon>
                {{ 'GLOBAL_SEARCH' | translate }}
              </ion-button>
            </div>
          </ion-col>
        </ion-row>

      </div>
    </div>
  </div>

  <div class="chempions" *ngIf="newDesign">

    <ion-row *ngIf="FIRST_LAYER && (appDetector.isForestApp() || (appDetector.isEventsApp() && isBrowser)) && noSearchField">
      <ion-col class="col-flex noSearchField" text-left>
        <ion-icon slot="start" name="arrow-back"></ion-icon>
        <ion-button fill="clear" color="light" (click)="onPopPage()">
          <strong>{{ 'GLOBAL_BACK' | translate }}</strong>
        </ion-button>
      </ion-col>
    </ion-row>

    <div class="podiums">
      <div class="leaders">

        <div class="avatars" *ngIf="clientResults.length > 0">

          <!-- SECOND AVATAR -->
          <div class="second-avatar" >
            <!-- *ngIf="clientResults[0]" -->
            <ion-avatar>
              <img class="image-circle" [src]="clientResults[0]?.picName || '/assets/imgs/default-image-32@3x.png'">
            </ion-avatar>
            <p class="name" *ngIf="clientResults[1]">{{ clientResults[0]?.athleteName }}</p>
            <div class="time" *ngIf="!isCharity && clientResults[1]">{{ clientResults[0]?.timeFormatted }}</div>
            <div class="time" *ngIf="isCharity && trackingService.options.distanceUnit === 0 && clientResults[1]">
              {{ (clientResults[0]?.strecke1 / 1000).toFixed(2) }} km
            </div>
            <div class="time" *ngIf="isCharity && trackingService.options.distanceUnit === 1 && clientResults[1]">
              {{ (clientResults[0]?.strecke1 / 1000 * 0.621371).toFixed(2) }} {{ 'MILES' | translate }}
            </div>
          </div>

          <!-- FIRST AVATAR -->
          <div class="first-avatar" >
            <!-- *ngIf="clientResults[1]" -->
            <ion-avatar>
              <img class="image-circle" [src]="clientResults[1]?.picName || '/assets/imgs/default-image-32@3x.png'">
            </ion-avatar>
            <p class="name" *ngIf="clientResults[1]">{{ clientResults[1]?.athleteName }}</p>
            <div class="time" *ngIf="!isCharity && clientResults[1]">{{ clientResults[1]?.timeFormatted }}</div>
            <div class="time" *ngIf="clientResults[1]&& isCharity && trackingService.options.distanceUnit === 0">
              {{ (clientResults[1]?.strecke1 / 1000).toFixed(2) }} km
            </div>
            <div class="time" *ngIf="isCharity && trackingService.options.distanceUnit === 1 && clientResults[1]">
              {{ (clientResults[1]?.strecke1 / 1000 * 0.621371).toFixed(2) }} {{ 'MILES' | translate }}
            </div>
          </div>

          <!-- THIRD AVATAR -->
          <div class="third-avatar" >
            <!-- *ngIf="clientResults[2]" -->
            <ion-avatar>
              <img class="image-circle" [src]="clientResults[2]?.picName || '/assets/imgs/default-image-32@3x.png'">
            </ion-avatar>
            <p class="name" *ngIf="clientResults[2]" >{{ clientResults[2]?.athleteName }}</p>
            <div class="time" *ngIf="!isCharity&&clientResults[2]">{{ clientResults[2]?.timeFormatted }}</div>
            <div class="time" *ngIf="isCharity && trackingService.options.distanceUnit === 0 && clientResults[2]">
              {{ (clientResults[2]?.strecke1 / 1000).toFixed(2) }} km
            </div>
            <div class="time" *ngIf="isCharity && trackingService.options.distanceUnit === 1 && clientResults[2]">
              {{ (clientResults[2]?.strecke1 / 1000 * 0.621371).toFixed(2) }} {{ 'MILES' | translate }}
            </div>
          </div>

        </div>

        <div *ngIf="clientResults.length === 0" class="no-results-block">
          <p>{{ 'GLOBAL_NO_RESULTS' | translate }}</p>
        </div>

        <div class="each-podium">
          <div class="second-podium"><p class="number">2</p></div>
          <div class="first-podium"><p class="number">1</p></div>
          <div class="third-podium"><p class="number">3</p></div>
        </div>

      </div>
    </div>

  </div>



  <!-- TODO: styling duplicates -->
  <ion-list #resultList *ngIf="searched && !isBrowser">
    <ion-item-divider class="padding-top" color="light"*ngIf="results.length !==0 || clientResults.length !==0"
      ><p>{{ 'GLOBAL_SEARCH_RESULTS' | translate }}</p></ion-item-divider>
      <ion-item-divider class="padding-top" color="light"*ngIf="results.length ==0 && clientResults.length ==0"
        ><p>{{ 'GLOBAL_NO_RESULTS' | translate }}</p></ion-item-divider>
    <result-search-list-item *ngFor="let result of results" [result]="result" [userSection]="userSection">
    </result-search-list-item>
    <result-ranglist-list-item *ngFor="let item of clientResults" [result]="item" [userSection]="userSection">
    </result-ranglist-list-item>
  </ion-list>

  <ion-list #resultList *ngIf="searched && isBrowser">
    <ion-item-divider class="padding-top" color="light"*ngIf="results.length !==0 || clientResults.length !==0"
    >{{ 'GLOBAL_SEARCH_RESULTS' | translate }}</ion-item-divider>
    <ion-item-divider class="padding-top" color="light"*ngIf="results.length ==0 && clientResults.length ==0"
      >{{ 'GLOBAL_NO_RESULTS' | translate }}</ion-item-divider>
    <result-search-list-item *ngFor="let result of results" [result]="result" [userSection]="userSection">
    </result-search-list-item>
    <result-ranglist-list-item  *ngFor="let item of clientResults" [result]="item" [userSection]="userSection">
    </result-ranglist-list-item>
  </ion-list>
 
  <!-- NEW MENU, FIRST LAYER -->
  <ion-list *ngIf="newMenu && !searched && FIRST_LAYER">
    <div *ngFor="let complex of getEventComplex(); index as i">
      <ion-item-divider class="list-header" color="light">
        <img class="list-header-img" src='../../../assets/imgs/sport_types/{{ complex.category }}.png'>
        <span>{{ complex.category | translate | uppercase }}</span>
      </ion-item-divider>
      <button ion-item class="list-item" *ngFor="let eventDetails of getAllEvents(i)"
        (click)="onEventLoad(eventDetails)">
        <ion-avatar slot="start">
          <img src="{{eventDetails.imgPath}}">
        </ion-avatar>
        <h4>{{ eventDetails.dateFormatted }}</h4>
        <h4 class="padding-left" style="white-space: nowrap;">{{ eventDetails.eventName }}</h4>
      </button>

      <ion-infinite-scroll (ionInfinite)="loadNextSportsPage($event, i)"
        *ngIf="getAllEvents(i).length % 10 === 0 && getAllEvents(i).length !== 0 && !appDetector.isEventsApp()">
        <ion-infinite-scroll-content loadingSpinner="bubbles"
          loadingText="{{ 'GLOBAL_SEARCH_LOADING_MORE' | translate }}">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
      <ion-item *ngIf="appDetector.isEventsApp()" class="ion-text-center">
        <ion-button (click)="onMorePress(complex)">
          {{ 'GLOBAL_MORE_RESULTS' | translate | uppercase }}
        </ion-button>
      </ion-item>
    </div>
  </ion-list>

  <!-- Second layer for events app -->
  <menu-layer-category eventType="{{ getEventType() }}" type="Results" (getTotalEvents)="onLoadThirdLayer($event)"
    *ngIf="SECOND_LAYER && !searched">
  </menu-layer-category>

  <!-- Third layer for events app -->
  <menu-layer-total eventType="{{ getEventType() }}" eventArea="{{ getEventArea() }}" type="Results"
    *ngIf="THIRD_LAYER && !searched">
  </menu-layer-total>

  <ion-infinite-scroll (ionInfinite)="loadNextPage($event)"
    *ngIf="isThurnauApp && (results.length % 10 === 0 && results.length > 0) || (clientResults.length % 10 === 0 && clientResults.length > 0)">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="{{ 'GLOBAL_SEARCH_LOADING_MORE' | translate }}">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>

  <ion-infinite-scroll (ionInfinite)="loadNextPage($event)"
    *ngIf="!isThurnauApp && (results.length % 25 === 0 && results.length > 0) || (clientResults.length % 25 === 0 && clientResults.length > 0)">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="{{ 'GLOBAL_SEARCH_LOADING_MORE' | translate }}">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>

  <!-- <ion-row *ngIf="newDesign">
    <ion-avatar></ion-avatar>
    <ion-avatar></ion-avatar>
    <ion-avatar></ion-avatar>
  </ion-row> -->
</ion-content>